import 'zone.js';

import './styles.scss';

import('./bootstrap');
